import { Paper, Stack, Table, TableCell, TableContainer, TableRow, Typography } from '@mui/material'
import React from 'react'
import { useMobile } from '../../../hooks/useMoblie'
import { capitalize } from '../../../utils'

const BookingInfo = ({ bookingInfo }) => {
    const isMobile = useMobile()
    return (
        <>
            <Stack
                spacing={2}
                sx={{
                    p: isMobile ? 2 : 4,
                }}
            >
                <Typography variant="h5">Requirement Details</Typography>
                <TableContainer component={Paper} sx={{ width: isMobile ? '100%' : '50%' }}>
                    <Table sx={{ minWidth: '40%' }}>
                        <TableRow>
                            <TableCell align="left" width={200}>
                                <Typography variant="body1">Job Type</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">
                                    &nbsp;
                                    {bookingInfo?.jobType
                                        ?.split('_')
                                        ?.map((item) => capitalize(item))
                                        .join(' ')}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Skills</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">&nbsp;{bookingInfo?.tags?.join(' ,')}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Workers Required</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Stack direction={isMobile ? 'column' : 'row'} spacing={1} fontSize={20}>
                                    <Typography component={'span'} variant="body1">
                                        Supervisor: {bookingInfo?.peopleRequired?.SUPERVISOR}
                                    </Typography>

                                    <Typography component={'span'} variant="body1">
                                        Helper: {bookingInfo?.peopleRequired?.HELPER}
                                    </Typography>

                                    <Typography component={'span'} variant="body1">
                                        Technician: {bookingInfo?.peopleRequired?.TECHNICIAN}
                                    </Typography>
                                </Stack>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Shift Timing</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">{bookingInfo?.schedule?.shiftTime}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Start Date</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">{bookingInfo?.schedule?.startDate.slice(0, 10)}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Booking Duration</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">{bookingInfo?.schedule?.bookingDuration}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Site Address</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">{bookingInfo?.siteAddress}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">State</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1"> {bookingInfo?.state}</Typography>{' '}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">City</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1"> {bookingInfo?.city}</Typography>
                            </TableCell>
                        </TableRow>
                    </Table>
                </TableContainer>

                <Typography variant="h5">Contact details</Typography>
                <TableContainer component={Paper} sx={{ width: isMobile ? '100%' : '50%' }}>
                    <Table>
                        <TableRow>
                            <TableCell align="left" width={200}>
                                <Typography variant="body1">Name</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1"> {bookingInfo?.userName}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Company Name</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">{bookingInfo?.cmpName}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Email</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">{bookingInfo?.email}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Phone Number: </Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="body1">{bookingInfo?.phoneNumber}</Typography>
                            </TableCell>
                        </TableRow>
                    </Table>
                </TableContainer>

                <Typography variant="h5">Additional Details</Typography>
                <TableContainer component={Paper} sx={{ width: isMobile ? '100%' : '50%' }}>
                    <Table>
                        <TableRow>
                            <TableCell align="left" width={200}>
                                <Typography variant="body1"> Wage Per Day</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Stack direction={isMobile ? 'column' : 'row'} spacing={1} fontSize={20}>
                                    <Typography variant="body1">
                                        Helper: {bookingInfo?.rateCard?.HELPER ?? 0}
                                    </Typography>
                                    <Typography variant="body1">
                                        Technician: {bookingInfo?.rateCard?.TECHNICIAN ?? 0}
                                    </Typography>
                                    <Typography variant="body1">
                                        Supervisor: {bookingInfo?.rateCard?.SUPERVISOR ?? 0}
                                    </Typography>
                                </Stack>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                <Typography variant="body1">Over Time Details</Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Stack direction={isMobile ? 'column' : 'row'} spacing={1} fontSize={20}>
                                    <Typography variant="body1">
                                        Over Time Factor : {bookingInfo?.overTime?.rate}
                                    </Typography>
                                    <Typography variant="body1">
                                        Over Time Buffer : {bookingInfo?.overTime?.buffer}&nbsp;
                                        {bookingInfo?.overTime?.bufferType}
                                    </Typography>
                                    {/* <Typography variant="body1">buffer Type : </Typography> */}
                                </Stack>
                            </TableCell>
                        </TableRow>
                    </Table>
                </TableContainer>
            </Stack>
        </>
    )
}

export default BookingInfo
